import React from "react";
import { useAxiosLoader } from "../../config/axios";
import "./style.css";
import logo from "../../assets/img/Logo_Branco_Estado_MT.png";
import { useSelector } from "react-redux";

export default (props) => {
  const count = useSelector((state) => state.counterRequestReducer.counterRequest);
  const isLoading = count > 0;

  function loader() {
    //let logoProdHml = `${window.location.origin}/${process.env.REACT_APP_BASE_URL}${logo.replace(".", "")}`;
    let logoProdHml = `${logo}`;

    return (
      <div className="loader-overlay">
        <img
          className="text"
          src={`${process.env.REACT_APP_AMBIENTE == "desenv" ? logo : logoProdHml}`}
          style={{ width: "13%" }}
          alt="loader"
        />
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <span className="msg">{props.text ? props.text : "Carregando"}</span>
      </div>
    );
  }
  return <>{isLoading ? loader() : false}</>;
};
